export class CCompanyInfoViewModel{
    fId:number;
    fCompanyName:string;
    fCompanyLogoHighQuality:string;
    fCompanyLogoLowQuality:string;
    fAddress:string;
    fTel1:string;
    fTel2:string;
    fTel3:string;
    fFax:string;
    fEmailAddress:string;
    fCompanyShortName:string;
    fHoursOfWork:string;
    fDescription:string;
    fLongitude:number;
    fLatitude:number;
    fAppiOSLink:string;
    fAppAndroidLink:string;

    constructor(){
        this.fId=0;
        this.fCompanyName='';
        this.fCompanyLogoHighQuality='';
        this.fCompanyLogoLowQuality='';
        this.fAddress='';
        this.fTel1='';
        this.fTel2='';
        this.fTel3='';
        this.fFax='';
        this.fEmailAddress='';
        this.fCompanyShortName='';
        this.fHoursOfWork='';
        this.fDescription='';
        this.fLongitude=0;
        this.fLatitude=0;
        this.fAppiOSLink='';
        this.fAppAndroidLink='';
    }
}